import {HasTenantResource, SoftDeleteResource} from "@hidat/huijs-resource";
import {AnyHash, FieldConfig, FieldDataTypes, uBoolean, uNumber, uString, Uuid} from "@hidat/huijs-common";
import {HasBinResource, RblFieldConfigs, RblTenantResourceInterface} from "../rbl-resource.interface";

export const LibraryBaseFields = [
  RblFieldConfigs.id,
  RblFieldConfigs.uid,
  RblFieldConfigs.bin,
  RblFieldConfigs.createdAt,

  RblFieldConfigs.name.setRequired(true),
  new FieldConfig('shortCode'),
  new FieldConfig('prototype'),
  new FieldConfig('isLibrary', FieldDataTypes.BOOLEAN),
  new FieldConfig('isCatalog', FieldDataTypes.BOOLEAN),
  new FieldConfig('containsMasters', FieldDataTypes.BOOLEAN),
  new FieldConfig('containsMasterLinks', FieldDataTypes.BOOLEAN),
  new FieldConfig('containsCollections', FieldDataTypes.BOOLEAN),
  new FieldConfig('canAddTo', FieldDataTypes.BOOLEAN),
  new FieldConfig('canPublishMediaTo', FieldDataTypes.BOOLEAN),
  new FieldConfig('canPublishListTo', FieldDataTypes.BOOLEAN),
  new FieldConfig('canImportInto', FieldDataTypes.BOOLEAN),
  new FieldConfig('trackShortCode', FieldDataTypes.BOOLEAN),
  new FieldConfig('itemCount', FieldDataTypes.INTEGER).setEditable(false),
  new FieldConfig('config', FieldDataTypes.HASH)
]

export interface LibraryBaseInterface extends RblTenantResourceInterface, HasBinResource, HasTenantResource {
  uid: Uuid | undefined;
  name: uString;
  prototype: uString;
  isLibrary: uBoolean;
  isCatalog: uBoolean;
  containsMasters: uBoolean;  // Should always be true for libraries
  containsMasterLinks: uBoolean;
  containsCollections: uBoolean;  //Depreciated???
  canAddTo: uBoolean;
  canPublishMediaTo: uBoolean;
  canPublishListTo: uBoolean;
  canImportInto: uBoolean;
  trackShortCode: uBoolean;
  itemCount: uNumber;
  config: AnyHash | undefined;
}
